import { isEmpty } from 'lodash';

export function shouldDispatchGenericError (res, store) {
    const env = store.env;
    // console.log('api.middlewares.shouldDispatchGenericError()', res);
    if (!isEmpty(res?.data?.error)) {
        if (env && env.errorsStore) {
            const errorsStore = env.errorsStore;
            errorsStore.dispatch(res.data.error);
        }
        return true;
    }
    return false;
}
